import { customIconSrcComponent } from "@/v2-ui/icon/custom/IconCustom"
import type { CustomIcons } from "@/v2-ui/icon/custom/icon.custom.types"

export function isCustomIcon(value: string): value is CustomIcons {
  return value in customIconSrcComponent
}
